// Mock data for Nortec Integrated Services

export const companyInfo = {
  name: "Nortec Integrated Services Pty Ltd",
  tagline: "Safe, High-Quality, Reliable Solutions",
  email: "admin@nortecis.com.au",
  phone: "+61 (0) 447 690 462",
  address: "Townsville, Qld, Australia",
};

export const heroContent = {
  title: "Delivering Excellence in Electrical & Technical Services",
  subtitle: "Supporting the long-term performance of your assets across residential, commercial, industrial, and emerging energy sectors",
  cta: "Get Started",
  ctaSecondary: "Learn More",
};

export const services = [
  {
    id: 1,
    title: "Renewable Energy",
    description: "Specialist capability across solar, wind, and hydrogen energy systems with comprehensive engineering and asset integrity support.",
    icon: "Zap",
    image: "/renewable-energy-cropped.jpg",
  },
  {
    id: 2,
    title: "Engineering Capabilities",
    description: "Expert electrical engineering services for power distribution, transmission, and control systems across all sectors.",
    icon: "Power",
    image: "https://images.unsplash.com/photo-1611599281058-94426d0618a7?w=800",
  },
  {
    id: 3,
    title: "Heavy Industry",
    description: "Integrated solutions for mining, manufacturing, and industrial facilities with focus on operational reliability.",
    icon: "Factory",
    image: "/heavy-industry.png",
  },
  {
    id: 4,
    title: "Construction Services",
    description: "Full electrical fit-outs, installations, and project delivery for construction projects of all scales.",
    icon: "Building",
    image: "/construction-services-new.jpg",
  },
  {
    id: 5,
    title: "Commercial & Residential",
    description: "Compliant, efficient electrical services from repairs to full system upgrades and planned maintenance programs.",
    icon: "Home",
    image: "/construction-services.jpg",
  },
  {
    id: 6,
    title: "Asset Management",
    description: "Transparent, practical asset integrity and management services ensuring cost-effective outcomes.",
    icon: "Settings",
    image: "/asset-management.png",
  },
];

export const aboutContent = {
  mission: "Nortec Integrated Services Pty Ltd (NIS) is committed to delivering safe, high-quality, and reliable services that support the long-term performance of our clients' assets across residential, commercial, industrial, and emerging energy sectors.",
  description: "We provide comprehensive electrical, technical, and management services with specialist capability across renewable energy, hydrogen, power systems, heavy industry, and construction sectors. Our integrated approach combines multidisciplinary expertise with over a decade of industry experience to deliver practical, value-driven solutions.",
  approach: "Working collaboratively with clients, we deliver transparent solutions spanning operations & maintenance, engineering, asset integrity, and project delivery. Our integrated approach ensures cost-effective outcomes, improved operational reliability, and targeted support that effectively bridges capability gaps across complex and diverse operations.",
  compliance: "Our technicians combine trade capability with strong technical expertise, ensuring all work meets Queensland's regulatory, safety, and performance requirements. We are a fully licensed electrical contractor (EC 1510727) with comprehensive qualifications and proven experience across all sectors we serve.",
  values: [
    { 
      title: "Safety First, Always", 
      description: "Our vision ensures every individual remains safe, supported, and protected. We embed safety into our culture, systems, and everyday actions."
    },
    { 
      title: "Integrated Service Delivery", 
      description: "Bridging capability gaps through multidisciplinary expertise and holistic asset lifecycle management solutions."
    },
    { 
      title: "Technical Excellence", 
      description: "Combining electrical, instrumentation, controls, and engineering expertise with practical industry knowledge."
    },
    { 
      title: "Operational Reliability", 
      description: "Delivering improved asset performance through proven O&M frameworks, preventative maintenance, and asset integrity services."
    },
  ],
};

export const mockSubmitContact = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry. We'll get back to you soon!" });
    }, 1000);
  });
};
